import { forwardRef } from "react";
import { useTabContext } from "@/contexts/TabContext";
import { cn } from "@/lib/utils";

interface TabNavLinkProps {
  to: string;
  end?: boolean;
  className?:
    | string
    | ((props: { isActive: boolean }) => string);
  children:
    | React.ReactNode
    | ((props: { isActive: boolean }) => React.ReactNode);
  onClick?: () => void;
}

export const TabNavLink = forwardRef<HTMLAnchorElement, TabNavLinkProps>(
  ({ to, end: _end, className, children, onClick, ...rest }, ref) => {
    const { openTab, activeTabId, tabs } = useTabContext();

    // A tab is "active" if it's the currently visible tab AND its path matches
    const activeTab = tabs.find((t) => t.id === activeTabId);
    const isActive = activeTab?.path === to;

    const cls =
      typeof className === "function" ? className({ isActive }) : className;
    const content =
      typeof children === "function" ? children({ isActive }) : children;

    return (
      <a
        ref={ref}
        href={to}
        className={cls}
        onClick={(e) => {
          e.preventDefault();
          openTab(to);
          onClick?.();
        }}
        {...rest}
      >
        {content}
      </a>
    );
  },
);

TabNavLink.displayName = "TabNavLink";
